import "../../../styles.css";
import React from "react";
import Lottie from "react-lottie-player";
import animationData from "../../../Assets/svgs/empty.json";
const Empty = () => {
  return (
    <>
      <div className="lottie">
        <Lottie
          loop={false}
          animationData={animationData}
          play
          style={{
            width: "auto",
            height: 300,
            display: "flex",
            justifyContent: "center",
          }}
        />
      </div>
      <p className="d-flex justify-content-center">No Record available!</p>
    </>
  );
};

export default Empty;
